<div>
  <h1>404 - Page Not Found</h1>
  <p>The page you are looking for does not exist.</p>
  <a routerLink="/dashboard">Go to Dashboard</a>
</div>